import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ScrollToTop component - scrolls to top of page on route change
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
